module.exports = __webpack_public_path__ + "static/media/SOLID-SLATE-LOGO-02.eec6c480.svg";